import React from 'react';
import classNames from 'classnames';
import { ArrowUp, ArrowDown } from 'lucide-react';
import styles from './SortIcons.module.scss';

export interface SortIconsProps {
    className?: string;
    sortDirection?: 'asc' | 'desc' | null;
    disabled?: boolean;
}

export const SortIcons = ({ className, sortDirection = null, disabled = true }: SortIconsProps) => {
    const rootClassName = classNames(
        styles.root,
        {
            [styles.disabled]: disabled,
        },
        className
    );

    return (
        <div className={rootClassName} data-testid='sort-icons-container'>
            {sortDirection === 'asc' && <ArrowUp size={16} aria-label='Sort ascending' />}
            {sortDirection === 'desc' && <ArrowDown size={16} aria-label='Sort descending' />}
        </div>
    );
};

export default SortIcons;
